import type { FC } from 'react';
import type { IIconProps } from '@/Module/Icon/Model';
import { BaseIcon } from './BaseIcon';
export const IconCrossMark: FC<IIconProps> = props => {
  return <BaseIcon {...props} data-sentry-element="BaseIcon" data-sentry-component="IconCrossMark" data-sentry-source-file="IconCrossMark.tsx">
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="IconCrossMark.tsx">
        <path d="M21 7L7 21" stroke="#18191F" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="IconCrossMark.tsx" />
        <path d="M7 7L21 21" stroke="#18191F" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="IconCrossMark.tsx" />
      </svg>
    </BaseIcon>;
};